module.exports = __webpack_public_path__ + "img/20240802143902799bi.1df72a38.png";